import React from 'react';
import styles from './TextGroupSectionE.module.sass';
import Section, { SectionBackgroundStyle } from '../../reusable/section/Section';
import TextContainer from '../../reusable/title_description_group_container/TitleDescriptionGroupContainer';
import { TextGroupStyle } from '../../reusable/title_description_group/TitleDescriptionGroup';
import Julia from '../../assets/julia.webp';
import MobileSpacer, { SpacerSize } from '../../reusable/mobile_spacer/MobileSpacer';
import Grid from '../../reusable/grid/Grid';
import RevealImage from '../../reusable/reveal/RevealImage';

const title = "Julia De Mars."
const subtitle = "Chief Coordinator & Communications Officer"
const paragraphs = [
  "Julia De Mars is a people-first communicator and creative professional based in Santa Monica, California. She holds a Bachelor's degree in Creative Writing with a minor in Psychology from Lesley University in Cambridge, Massachusetts, and is currently applying to graduate programs to pursue her Master’s in Counseling. With a strong background in front-of-house roles across hospitality and service industries, Julia brings a grounded, empathetic approach to every interaction - whether she’s coordinating logistics or supporting client care.",
  "After volunteering with the MOST Kids team, Julia is thrilled to officially join the practice as Chief Coordinator & Communications Officer, where she combines her deep passion for helping others and a love for clear, compassionate communication.",
  "Outside of work, she loves travelling, going to comedy shows, and eating good food with family and friends.",
];

export default class TextGroupSectionE extends React.Component {

  render() {
    return (
      <Section style={SectionBackgroundStyle.mediumLight}>
        <RevealImage className={styles.Julia} src={Julia} photo />
        <MobileSpacer size={SpacerSize.medium} />
        <Grid>
          <TextContainer
            className={styles.TextContainer}
            dark
            title={title}
            subtitle={subtitle}
            paragraphs={paragraphs} 
            style={TextGroupStyle.small} />
        </Grid>
      </Section>
    )
  }

}